import { h } from "preact";
import { formatMoney } from "@helpers/currency";

function MiniCartThresholdMessage() {
  const minimumCartThreshold =
    window.themeVars.config.cart.minimumCartThreshold;

  const formattedMinimumCartThreshold = formatMoney(
    minimumCartThreshold,
    true,
    false,
  );

  return (
    <div className="minicart__cart-threshold-error">
      <span
        className="minicart__cart-threshold-error-icon"
        dangerouslySetInnerHTML={{
          __html: window.themeVars.icons.error,
        }}
      ></span>

      <p
        className="
        minicart__cart-threshold-error-text
        text-sm-body--semi-bold
      "
      >
        {window.themeVars.strings.cart.cartUnderValue.replace(
          "{{ value }}",
          formattedMinimumCartThreshold,
        )}
      </p>
    </div>
  );
}

export default MiniCartThresholdMessage;
